import { useRef, useEffect, useCallback } from 'react';

interface CanvasChartProps {
  onDraw: (ctx: CanvasRenderingContext2D, width: number, height: number) => void;
  height?: number;
  className?: string;
  testId?: string;
}

export function CanvasChart({ onDraw, height = 200, className, testId }: CanvasChartProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  const draw = useCallback(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    const dpr = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * dpr;
    canvas.height = rect.height * dpr;
    ctx.scale(dpr, dpr);
    ctx.clearRect(0, 0, rect.width, rect.height);
    onDraw(ctx, rect.width, rect.height);
  }, [onDraw]);

  useEffect(() => {
    draw();
    const canvas = canvasRef.current;
    if (!canvas) return;
    const observer = new ResizeObserver(() => draw());
    observer.observe(canvas.parentElement || canvas);
    return () => observer.disconnect();
  }, [draw]);

  return (
    <canvas
      ref={canvasRef}
      data-testid={testId}
      className={`w-full ${className || ''}`}
      style={{ height: `${height}px` }}
    />
  );
}
